import styled from "styled-components";

export const FooterStyled = styled.footer`
      -webkit-box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.5);
      -moz-box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.5);
      box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.5);
      background-color: #161F6E;
      display: block;
  
      & #logo_TT {
        height: 12vh;
      }
  
      position: relative;
      z-index: 99;
    `;
